import { render, staticRenderFns } from "./LpOptPopup.vue?vue&type=template&id=321eb31e&scoped=true"
import script from "./LpOptPopup.vue?vue&type=script&lang=js"
export * from "./LpOptPopup.vue?vue&type=script&lang=js"
import style0 from "./LpOptPopup.vue?vue&type=style&index=0&id=321eb31e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321eb31e",
  null
  
)

export default component.exports